var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerBottomButton } from '../../layout/answerbottom/AbfragerBottomButton';
import { AbfragerBottomLine } from '../../layout/answerbottom/AbfragerBottomLine';
import { AbfragerAnswerBottomFeedbackText } from './AbfragerAnswerBottomFeedbackText';
let ShowQuestionAnswerBottomAnswering = class ShowQuestionAnswerBottomAnswering extends React.PureComponent {
    render() {
        const { question } = this.props;
        const left = (React.createElement(React.Fragment, null,
            question.context.app.answer.answerInfo.indexInTray > 0 && (React.createElement(AbfragerBottomButton, { typ: 2, onClick: question.context.app.cycle.cycleNavigate.handlePreviousClick, aspect: question.context.stage.ownAspect.button_history_back },
                React.createElement("i", { className: "fas fa-angle-left" }),
                " Zur\u00FCck")),
            React.createElement(AbfragerAnswerBottomFeedbackText, { question: question })));
        return (React.createElement(AbfragerBottomLine, { left: left, right: React.createElement("div", { style: { flex: '0 1 auto', display: 'flex' } },
                React.createElement(AbfragerBottomButton, { typ: 1, onClick: question.answer.answerSkip.blockQuestion }, "Blockieren"),
                React.createElement(AbfragerBottomButton, { typ: 0, onClick: question.answer.answerSkip.skipQuestion }, "\u00DCberspringen")) }));
    }
};
ShowQuestionAnswerBottomAnswering = __decorate([
    observer
], ShowQuestionAnswerBottomAnswering);
export { ShowQuestionAnswerBottomAnswering };
